<template>
  <div class="hello">
    <h1>NestForms Page Not Found</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
